import { MappedTemplate, Project, Role, Template } from './types';

export const mapTemplate = (template?: Template): MappedTemplate[] => {
  if (!template || !template.projects || template.projects.length === 0) {
    return [];
  }

  return template.projects.map((project: Project) => {
    if (!project.roles || project.roles.length === 0) {
      return {
        id: project?.name,
        label: project?.name,
        children: [],
      };
    }

    const roles = project.roles.map((role: Role) => {
      const attributes = role?.attributes || [];
      const isSelfReferential =
        attributes.length === 1 && attributes[0] === role.name;

      return {
        id: role?.name,
        label: role?.name,
        children: isSelfReferential
          ? []
          : attributes.map(attribute => ({
              id:
                attribute === role.name
                  ? `${role.name}:${attribute}`
                  : attribute,
              label: attribute,
            })),
      };
    });

    return {
      id: project?.name,
      label: project?.name,
      children: roles,
    };
  });
};

export const getSelectedPermissionsWithParents = (
  selected: Set<string>,
  templates?: MappedTemplate[],
): Set<string> => {
  const result = new Set<string>(selected);

  for (const template of templates || []) {
    if (!template.children || template.children.length === 0) {
      continue;
    }

    let allRolesSelected = true;

    for (const role of template.children) {
      if (!role.children || role.children.length === 0) {
        if (!selected.has(role.id)) {
          allRolesSelected = false;
        } else {
          result.add(role.id);
        }
        continue;
      }

      const allAttributesSelected = role.children.every(attr =>
        selected.has(attr.id),
      );

      if (allAttributesSelected) {
        result.add(role.id);
      } else {
        allRolesSelected = false;
      }
    }

    if (allRolesSelected) {
      result.add(template.id);
    }
  }

  return result;
};

export const getLeafNodesOnly = (
  selected: string[],
  templates: MappedTemplate[],
): string[] => {
  const leafNodes: string[] = [];
  const parentIds = new Set<string>();

  for (const template of templates) {
    parentIds.add(template.id);

    if (template.children) {
      for (const role of template.children) {
        if (role.children && role.children.length > 0) {
          parentIds.add(role.id);
        }
      }
    }
  }

  for (const attr of selected) {
    if (!parentIds.has(attr)) {
      const parts = attr.split(':');
      if (parts.length === 2 && parts[0] === parts[1]) {
        leafNodes.push(parts[0]);
      } else {
        leafNodes.push(attr);
      }
    }
  }

  return leafNodes;
};
